import { Routes, Route, Navigate } from 'react-router';
import Login from './pages/Login';
import MagicCallback from './pages/MagicCallback';
import Dashboard from './pages/Dashboard';
import Log from './pages/Log';
import Symptoms from './pages/Symptoms';
import Handovers from './pages/Handovers';
import Calendar from './pages/Calendar';
import Documents from './pages/Documents';
import Reminders from './pages/Reminders';
import Meals from './pages/Meals';
import Summary from './pages/Summary';
import Settings from './pages/Settings';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/verify" element={<MagicCallback />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/log" element={<Log />} />
        <Route path="/symptoms" element={<Symptoms />} />
        <Route path="/handovers" element={<Handovers />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/reminders" element={<Reminders />} />
        <Route path="/meals" element={<Meals />} />
        <Route path="/summary" element={<Summary />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin" element={<Admin />} />
      </Route>
      <Route path="*" element={<NotFound />} />
      <Route path="/404" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
